const doc = [({"ja":({"adminComponentCompanyInvoice":({"companyInvoiceIndexTitle":"請求一覧"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;